<template>
  <div class="tabPaneConrtent-card" @click="viewDetails">
    <div class="tabPaneConrtent-card-content">

      <div class="tabPaneConrtent-card-content-img">
        <img :src="imgUrl" alt="" style="width: 100%; height: 100%">
      </div>
    </div>
    <div>
      <div class="tabPaneConrtent-card-content-title">{{ item.input988275a1 }}</div>
      <div class="tabPaneConrtent-card-content-jianjie">{{ item.inputde060c84 }}</div>
      <div class="tabPaneConrtent-card-content-xiangqing" @click="viewDetails">查看详情</div>
    </div>
  </div>
</template>

<script setup>

import { computed } from 'vue'
import { useRoute, useRouter } from "vue-router"

const router = useRouter()
const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  }
})

const emit = defineEmits(['viewDetails'])

const getImgUrl = (item) => {
  if (item['picture-uploadc8da899c'] && item['picture-uploadc8da899c'].length > 0) {
    return item['picture-uploadc8da899c'][0].url
  } else {
    return ""

  }
}


const item = computed(() => {
  return props.item
})

const imgUrl = computed(() => {
  return getImgUrl(props.item)
})

const viewDetails = () => {
  router.push({
    query: {
      id: item.value.rowId
    }

  })
  emit('viewDetails', item.value)
}
</script>

<style scoped lang="less">
.tabPaneConrtent-card {
  // width: 249px;
  // height: 246px;
  width: 100%;
  height: 375px;
  box-shadow: 0px 1px 5px 0px rgba(185, 196, 218, 0.4);
  cursor: pointer;
  margin: 0 9px;
  padding: 10px 10px;
  margin-bottom: 30px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  font-family: 'PuHuiTi';
}

.tabPaneConrtent-card:hover {
  box-shadow: 0px 2px 8px 0px rgba(185, 196, 218, 0.80);
}

.tabPaneConrtent-card-content {
  width: 100%;
  height: 60%;
  background-size: 100% 100%;

}

.tabPaneConrtent-card-content-title {
  color: rgba(51, 51, 51, 1);
  font-weight: 500;
  width: 100%;
  font-size: 16px;
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 10px;
  padding-left: 10px;
}

.tabPaneConrtent-card-content-img {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-top-left-radius: 5px;
}

.tabPaneConrtent-card-content-jianjie {
  padding: 10px 10px;
  height: 75px;
  font-size: 14px;
  color: rgba(92, 95, 101, 1);
  word-break: break-all;
  /* 在恰当的断字点进行换行 */
  overflow: hidden;
  /* 超出范围隐藏 */
  text-overflow: ellipsis;
  /* 文字超出用省略号 */
  display: -webkit-box;
  /* 盒子模型 */
  -webkit-line-clamp: 3;
  /* 显示的文本行数 */
  -webkit-box-orient: vertical;
  /* 子元素的垂直排列方式 */
}

.tabPaneConrtent-card-content-xiangqing {
  margin-top: 5px;
  margin-left: 10px;
  display: inline-block;
  color: rgba(32, 129, 235, 1);
}
</style>